var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fetchingOutputPreset && !_vm.fetchingEmptyOutputPreset)?_c('output-preset-details'):_c('loading-page')}
var staticRenderFns = []

export { render, staticRenderFns }